type Names = [pattern: RegExp, name: string][];

const BROWSERS: Names = [
  [/Edg(e|A|iOS)?\//, 'Edge'],
  [/OPR\//, 'Opera'],
  [/Firefox\/|FxiOS\//, 'Firefox'],
  [/Chrome\/|CriOS\//, 'Chrome'],
  [/Safari\//, 'Safari'],
];

const SYSTEMS: Names = [
  [/iPad/, 'iPad'],
  [/iPhone/, 'iPhone'],
  [/Android/, 'Android'],
  [/CrOS/, 'ChromeOS'],
  [/Macintosh/, 'Mac'],
  [/Windows/, 'Windows'],
  [/Linux/, 'Linux'],
];

const firstName = (userAgent: string, names: Names) =>
  names.find(([pattern]) => pattern.test(userAgent))?.[1];

export const deviceLabelFor = (userAgent: string) =>
  [firstName(userAgent, BROWSERS), firstName(userAgent, SYSTEMS)].filter(Boolean).join(' on ') ||
  undefined;
